import React from "react";

const Footer = () => {
  let dat = new Date();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="https://hotplotz.com/" target="_blank"  rel="noreferrer">
            HotplotZ
          </a>{" "}
          {dat.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
